// Navigation and directional icons
import ArrowBackIcon from './arrow-back-solid.svg';
import ArrowForwardIcon from './arrow-forward-solid.svg';
import ArrowUpIcon from './arrow-up-solid.svg';

export { ArrowBackIcon, ArrowForwardIcon, ArrowUpIcon };
